import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { TableContext } from '../../../components/Table/TableContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useReUploadDriverInfo = () => {
  const modalContext = useContext(ModalContext);
  const request = useHttps();
  const tableContext = useContext(TableContext);
  const [loading, setLoading] = useState(false);

  const onReUploadDriverInfoError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while re-uploading driver info.',
    );
  };

  const onReUploadDriverInfoSuccess = (callbackFn: () => void) => ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Driver info re-uploaded successfully.');
    tableContext?.setRefreshTable(!tableContext.refreshTable);
    modalContext?.setShowModal(false);
    callbackFn();
  };

  const reUploadDriverInfo = (data: any, driverId: string, callbackFn: () => void) => {
    const formData = new FormData();

    if (data?.profilePicture) {
      formData.append('profilePicture', data.profilePicture);
    }

    if (data?.firstName) {
      formData.append('firstName', data.firstName);
    }
    if (data?.lastName) {
      formData.append('lastName', data.lastName);
    }
    if (data?.nin) {
      formData.append('nin', data.nin);
    }
    if (data?.dateOfBirth) {
      formData.append(
        'dateOfBirth',
        data.dateOfBirth,
      );
    }
    formData.append('driverId', driverId);
    const url: HttpConfig = {
      url: `api/v1/dispatchers/validation/re-upload`,
      method: 'post',
      data: formData,
    };
    request(url, onReUploadDriverInfoSuccess(callbackFn), setLoading, onReUploadDriverInfoError);
  };

  return { reUploadDriverInfo, loading };
};

export default useReUploadDriverInfo;
